import { OperatorFunction, pipe } from 'rxjs';
import { mapTo } from 'rxjs/operators';

import { AuthService } from '../../auth/auth.service';
import {
    DeliveryType,
    FocusContainerRefDto,
} from '../../coaching-base/general';
import {
    NotificationDispatchDto,
    NotificationScenario,
    ShareContext,
} from '../../coaching-base/notifications';
import { CommitmentService } from '../../coaching-commitment/services/commitment.service';
import { manageNotes } from '../../coaching-note/note-detail.form';
import { Dependencies } from '../../store';
import { determineNotificationAddress } from '../determine-notification-address';

import * as actions from './observation.action';
import { ChainGroup } from './observation.epic';
import {
    CoachingInteractionModel,
    InteractionScoringModel,
    ObservationEvent,
} from './observation.model';

// TODO transformer?
export function composeObservation<TPayload>(
    grp: ChainGroup<TPayload>,
    deliveryTypeId: DeliveryType,
    startTime: Date,
    duration: number,
    focusContainers: FocusContainerRefDto[],
    // interactions: Array<CoachingInteractionModel>,
    // notes: Array<NoteDetails>,
    share: boolean,
    publish: boolean,
): ObservationEvent {
    const manageScoring = (
        scoring_: InteractionScoringModel[],
        owner: CoachingInteractionModel,
    ): InteractionScoringModel[] => {
        return (scoring_ || []).map((e) => ({
            ...e,
            interactionScoringId:
                e.interactionScoringId != null ? e.interactionScoringId : 0, // reasons
            interactionId:
                owner.interactionId != null ? owner.interactionId : undefined,
            proficiencyDelivered:
                e.proficiencyDelivered > 0 ? e.proficiencyDelivered : undefined, // TODO revise what if configured min is > 1 or <= 0
            consistencyDelivered:
                e.consistencyDelivered > 0 ? e.consistencyDelivered : undefined, // TODO revise what if configured min is > 1 or <= 0
            confidenceDelivered:
                e.confidenceDelivered > 0 ? e.confidenceDelivered : undefined, // TODO revise what if configured min is > 1 or <= 0
            focusId: e.focusId != null ? e.focusId : undefined,
        }));
    };

    return {
        eventId: grp.event.eventId != null ? grp.event.eventId : 0, // reasons
        eventTypeId: grp.event.eventTypeId,
        deliveryTypeId: grp.event.published
            ? grp.event.deliveryTypeId
            : deliveryTypeId,
        sessionDate: grp.event.sessionDate,
        duration: grp.event.published ? grp.event.duration : duration,
        shareWithPerformer: share,
        published: publish,
        startTime: grp.event.published ? grp.event.startTime : startTime,
        endTime: grp.event.published
            ? grp.event.endTime
            : new Date(startTime.getTime() + duration * 60000),
        participants: [grp.performer, grp.observer]
            .filter((e) => !!e)
            .map((e) => ({
                eventId: grp.event.eventId != null ? grp.event.eventId : 0, // reasons
                userId: e.userId,
                coachingRoleId: e.coachingRoleId,
            })),
        /* interactions: (interactions || []).map(e => ({
            ...e,
            interactionId: e.interactionId != null ? e.interactionId : 0, // reasons
            interactionIdentifier: e.interactionIdentifier ? e.interactionIdentifier : '',
            performerId: grp.performer.userId,
            observerId: grp.observer.userId,
            queueId: e.queueId != null ? e.queueId : undefined,
            notes: manageNotes(e.notes, grp.performer.userId, publish),
            tags: manageTags(e.tags, grp.performer.userId),
            scoring: manageScoring(e.scoring, e)
        })),
        notes: manageNotes(notes, grp.performer.id, publish), */
        interactions: null,
        notes: null,
        focusContainers: (focusContainers || []).map((ctr) => ({
            ...ctr,
            metrics: ctr.metrics || [],
            interactions: (ctr.interactions || []).map((e) => ({
                ...e,
                interactionId: e.interactionId != null ? e.interactionId : 0, // reasons
                interactionIdentifier: e.interactionIdentifier
                    ? e.interactionIdentifier
                    : '',
                performerId: grp.performer.userId,
                observerId: grp.observer.userId,
                queueId: e.queueId != null ? e.queueId : undefined,
                notes: manageNotes(e.notes, grp.performer.userId, publish),
                scoring: manageScoring(e.scoring, e),
            })),
        })),
    };
}

// TODO post-refactor. sync coaching.common.notification.service>generateNotification
// TODO revise. maybe merge with commitment-functions' createNotification
export function sendNotification<TPayload>(
    deps: Dependencies,
    grp: ChainGroup<TPayload>,
    act: actions.RootSendNotificationAction,
): OperatorFunction<any, ChainGroup<TPayload>> {
    const service = deps.injector.get<CommitmentService>(CommitmentService);
    const authService = deps.injector.get<AuthService>(AuthService);

    const { from, to } = determineNotificationAddress(
        authService.user.id,
        grp.performer,
        grp.observer,
    );
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const context = {} as ShareContext;

    if (act.scenario === NotificationScenario.SHARE) {
        context.url = `/coaching-detail/${grp.performer.userId}/observation/${grp.event.eventId}?backOnCancel`;
    }

    const notiDto: NotificationDispatchDto[] = [
        {
            scenario: act.scenario,
            fromUserId: from,
            toUserIds: [to],
            context,
        },
    ];

    return pipe(
        service.createNotifications(() => notiDto),
        mapTo(grp),
    );
}
